import groq from 'groq';
import { BLOG, SCIENCE } from 'lib/constants/routes';

import { RICH_TEXT } from '../common/richText';

export const FACTS = groq`
  _type,
  title,
  button {
    label,
    "link": select(
      link->_type == "timeline_scienceV2" => "${SCIENCE}",
      link->_type == "timeline_article" => "${BLOG}/" + link->slug.current,
      ""
    )
  },
  facts[] {
    title,
    subtitle,
    description[] {
      ${RICH_TEXT}
    },
    link,
    modalId
  },
`;

export const FACTS_BLOCK = groq`
  _type == 'timeline_facts' => @-> {
    ${FACTS}
  }
`;
